<template lang="pug">
  .brief-info(v-loading="loading")
    div
      span {{ $t("概览") }}
      campaign-info(
        :data="basicInfo.company_information"
      )
    div
      span {{ $t("联系人") }}
      contact-info(
        v-if="basicInfo"
        :data="basicInfo.user"
      )
    div
      div
        span {{ $t("联系人") }}
        div(v-if="basicInfo.company_information.company_information != null") {{ basicInfo.company_information.company_introduction }}
        div.empty-content__hint(v-else) {{ $t("暂无数据") }}
      div
        span {{ $t("资质与奖项") }}
        experience-and-awards(
          v-if="basicInfo"
          :award="basicInfo.experience_award.award"
          :qualification="basicInfo.company_information.qualification"
        )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CampaignInfo from './components/CampaignInfo'
import ContactInfo from './components/ContactInfo'
import ExperienceAndAwards from './components/ExperienceAndAwards'
import axios from 'axios'

export default {
  components: {
    TitleBar,
    CampaignInfo,
    ContactInfo,
    ExperienceAndAwards
  },
  data () {
    return {
      basicInfo: {
        company_introduction: {},
        category_scope: [],
        company_information: {},
        experience_award: {}
      },
      experienceInfo: null,
      loading: false
    }
  },
  computed: {
    vendorId () {
      return this.$store.state.vendor.id
    }
  },
  mounted () {
    this.fetchBasicInfo()
    this.fetchExperienceInfo()
  },
  methods: {
    fetchBasicInfo () {
      this.loading = true
      axios
        .get('/vendor/vendor/getBasicInfo', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then(res => {
          this.basicInfo = res
          this.loading = false
        })
    },
    fetchExperienceInfo () {
      this.loading = true
      axios
        .get('/vendor/vendor/getVendorExperience', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then(res => {
          this.experienceInfo = res
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus">
.brief-info
  > div
    padding 24px 0
    border-bottom solid 1px #e8e8e8
    > span:nth-child(1)
      display inline-block
      font-size 16px
      color #262626
      font-weight 600
      margin-bottom 16px
  > div:nth-child(1)
    padding-top 0
  > div:nth-child(3)
    display flex
    border-bottom none
    > div
      > span:nth-child(1)
        display inline-block
        font-size 16px
        color: #262626
        font-weight: 500
        margin-bottom 16px
    > div:nth-child(1)
      width 700px
      > div
        width: 520px
        color #595959
    .empty-content__hint
      color $disabled !important

</style>
